export enum DateField {
  From = 'from',
  To = 'to',
}

export enum CateringChoice {
  Needed = 'needed',
  NotNeeded = 'not_needed',
}

export enum CateringStatusType {
  New = 'New',
  Error = 'Error',
  Confirmed = 'Confirmed',
  Canceled = 'Canceled',
}

export enum DestinationSystemType {
  Riga = 'Riga',
  Milly = 'Milly',
  None = 'None',
}

export enum SubmitApplicationErrorCode {
  PeriodOverlaps = 'NonAttendanceRequestPeriodOverlaps',
}

export interface AbsencePeriod {
  from: string;
  to: string;
}

export interface AbsenceApplication {
  id: number;
  absencePeriod: AbsencePeriod;
  isCanceled: boolean;
  isExpired: boolean;
}

export interface NonAttendanceApplicationProperties {
  isCateringEnabled: boolean;
  isRigaCateringEnabled: boolean;
  periodLimitInDays: number;
  validPeriod: AbsencePeriod;
}

export interface SubmitNonAttendanceApplicationRequest {
  datePeriod: AbsencePeriod;
  applicationText: string;
  isCateringCanceled?: boolean;
}

export interface AuthorReference {
  authorName: string;
  timeModified: string;
}

export interface CateringRequest {
  isCateringCanceled: boolean;
  destinationSystemType: DestinationSystemType;
  statusType: CateringStatusType;
  cateringPeriod: AbsencePeriod;
  canceledPeriod?: AbsencePeriod;
  timeCanceled?: string;
}

export interface NonAttendanceApplicationDetail {
  id: number;
  isCanceled: boolean;
  isExpired: boolean;
  reasonText: string;
  absencePeriod: AbsencePeriod;
  canceledPeriod?: AbsencePeriod;
  isCateringRequestCanceledAfterDeadline?: boolean;
  createdBy: AuthorReference;
  canceledBy?: AuthorReference;
  cateringRequest?: CateringRequest;
}
